export enum OPTIONGROUP_TYPES {
  GUEST = "guest",
  BOOKING = "booking",
}

